import { Icon, OutlinedCardWithBanner, Row, Text } from "@bridgesplit/ui";

export function DisclaimerBanner({ message }: { message: string }) {
    return (
        <OutlinedCardWithBanner
            padding={0}
            banner={
                <Row
                    spacing={1}
                    sx={{
                        alignItems: "flex-start",
                        backgroundColor: ({ palette }) => `${palette.warning.main}1A`,
                        p: 2
                    }}
                >
                    <Text color="warning" sx={{ svg: { fontSize: "inherit" } }}>
                        <Icon type="warning" />
                    </Text>
                    <Text variant="body2" color="warning">
                        {message}
                    </Text>
                </Row>
            }
        >
            {null}
        </OutlinedCardWithBanner>
    );
}
